import React, { useState } from 'react';
import Button from '../../../../Components/Button/Button';
import DENTModalOverviewSurfaces from '../DENTModalOverviewSurfaces/DENTModalOverviewSurfaces';
import { useToothRestorationSurfaces } from '../../Hooks/Tooth/Restoration/useToothRestorationSurfaces';
import DENTModalOverviewRestorationVeneer from '../DENTModalOverviewRestorationButtons/DENTModalOverviewRestorationVeneer';
import { ToothRestorationType } from '../../../../graphql/graphql';

interface Props {
	restorationType: ToothRestorationType;
}

const DENTToothQuickRestorationModalVeneerButtons = ({
	restorationType,
}: Props) => {
	const [showSurfaces, setShowSurfaces] = useState(false);
	const { showedSurfaces, selectedSurfaces, handleSelectSurface } =
		useToothRestorationSurfaces(restorationType);

	const surfaceHandler = {
		showedSurfaces,
		selectedSurfaces,
		handleSelectSurface,
	};

	return (
		<>
			{showSurfaces ? (
				<>
					<DENTModalOverviewSurfaces
						onSelectSurface={handleSelectSurface}
						surfaces={surfaceHandler}
					/>
					<Button
						title={
							'patientTreatment.meddiDENT.dentalCross.quickAdjustment.hideSurfaces'
						}
						onClick={() => setShowSurfaces(false)}
					/>
				</>
			) : (
				<Button
					title={
						'patientTreatment.meddiDENT.dentalCross.quickAdjustment.showSurfaces'
					}
					onClick={() => setShowSurfaces(true)}
				/>
			)}
			<DENTModalOverviewRestorationVeneer />
		</>
	);
};

export default DENTToothQuickRestorationModalVeneerButtons;
